import { action, message, redirect } from "./globals";
import { getPackageVersion } from "./package";
import { displayMessage } from "./utilities";

let version = '';

function addVersionToUrl (url) {
    let params = '';
    if(version.length > 0){
        let separator = (url.indexOf('?') != -1)? '&' : '?';
        params = separator + version;
    }
    return params;
}

function evaluateFunctionByName (name) {
    const parts = name.split('.');
    let fn = parts.pop();
    let scope = window;
    //strip from parenthesis if needed
    if (fn.indexOf('(') !== -1) {
        fn = fn.substring(0, fn.indexOf('('));
    }
    //manage namespaces
    for (let i = 0, len = parts.length; i < len; i++) {
        scope = scope[parts[i]];
    }
    return scope[fn];
}

export function fireEvent (eventType) {
    //display message
    displayMessage(message[eventType]);
    //launch action
    if (action[eventType]) {
        const fn = evaluateFunctionByName(action[eventType]);
        if (typeof fn === 'function') {
            fn.apply(this, [eventType]);
        }
    }
    //redirect
    if (redirect[eventType] && redirect[eventType].length > 0) {
        version = 'version=' + getPackageVersion();
        document.location = redirect[eventType] + addVersionToUrl(redirect[eventType]);
    }
}